import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ApiServiceService } from '../../api-service.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { PasswordResetModalComponent } from '../password-reset-modal/password-reset-modal.component';
import { SessionService } from 'src/app/session.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  hide = true;
  sessionID: string = '';
  returnUrl: string = '/';
  appVersion = environment.version;
  isDemo = environment.isDemo;
  backgroundColor = environment.backgroundColor;

  login_form = new FormGroup({
    user: new FormControl('', Validators.required),
    pass: new FormControl('', Validators.required),
  });

  resetData:any;
  employeeId:any;
  isTempPass:boolean=false;
  isPassExpired:boolean=false;
  userName:string | undefined;
  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    public dialog: MatDialog,
    private sessionService: SessionService
  ) {this.sessionService.isAuthenticated =false}

  ngOnInit(): void {}

  userLogin() {
    this.generateUniqueID();
    let info = {
      user: this.login_form.get('user')?.value,
      pass: this.login_form.get('pass')?.value,
      sessionid: this.sessionID,
    };

    this.apiService.verify_signin(info).subscribe(async (res: any) => {
      this.resetData = res?.data[0];
      this.employeeId = this.resetData?.employeeID;
      this.isTempPass = this.resetData?.is_temp_password;
      this.isPassExpired = this.resetData?.password_expired;
      this.userName = this.resetData?.email ;
      if (res.message === 'Success') {
        this.apiService.updateSession(info).subscribe((res: any) => {
          if (res.message == 'Success') {
            //Update the table with sessionID
            localStorage.setItem('SESSIONID', this.sessionID);
            if (this.returnUrl == '/') {
              this.router.navigate(['dashboard']); //
              this.sessionService.setPassword(this.resetData?.session_lock)
            } else {
              this.router.navigateByUrl(this.returnUrl); // open the url that the session got expired
            }
            this.apiService.setLoggedIn(true);
          }
        });
      } else if (res.message === 'Temp' || res.message === 'Expired') {
        this.openPasswordModal();
      } else {
        alert(res.message);
      }
    });
  }

  generateUniqueID() {
    let chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let uniqueLength = 41;
    this.sessionID = '';
    for (let i = 0; i < uniqueLength; i++) {
      let randNumber = Math.floor(Math.random() * chars.length);
      this.sessionID += chars.substring(randNumber, randNumber + 1);
    }
  }

  openPasswordModal() {
    const dialogRef = this.dialog.open(PasswordResetModalComponent, {
      width: '500px',
      data: {employeeId:this.resetData?.employeeID, userName:this.userName, isTempPass: this.isTempPass, isPassExpired: this.isPassExpired}
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   this.client_form.controls['pull_consent'].setValue(result);
    //   this.isConsentDisbable = result;
    // });
  }
}
